// extracted by mini-css-extract-plugin
export default {"container":"abtasty-qa-assistant__PageLoader-module__container___i2eMy","text":"abtasty-qa-assistant__PageLoader-module__text___ECv2j"};